import $ from "jquery";
import "./scss/style.scss?1";
import "./js/helper.js?1";
import "./js/slick.js?1";
import "./js/observer.js?1";
import "./js/custom.js?1";
import "./js/dynamicmesh.js?1";
import "./js/elementsconnector.js?1";
import "./js/googlemaps.js?1";
import "./js/videoframe.js?1";
//import "./js/masonry.js";

//console.log('Slick integriert');
//console.log('wp-scripts');

$('.videowithoverlay .kopfslider').slick({
    arrows: false,
    dots: false,
    autoplay: true, 
    autoplaySpeed: 6000
});
$('.zeitstrahl_slider').slick({
    arrows: true,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: $('.zeitstrahl_slider').data('endlos') ? $('.zeitstrahl_slider').data('endlos') : false,
    initialSlide : $('.zeitstrahl_slider').data('startslide') ? parseInt($('.zeitstrahl_slider').data('startslide'),10) : 0,
    responsive: [
        {
          breakpoint: 1280,
      centerMode: false,
          settings: {
            slidesToShow: 4,
          }, 
        },
        {
            breakpoint: 1080,
        centerMode: false,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 780,
        centerMode: false,
            settings: {
              slidesToShow: 1,
            },
          },
      ],
});
